import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/nicola/workspace/react-csv-reader/node_modules/gatsby-theme-docz/src/base/Layout.js";
import CSVReader from '../src';
import { Props, Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "csvreader"
    }}>{`CSVReader`}</h1>
    <p>{`Bare minimal example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import * as React from 'react'
import CSVReader from 'react-csv-reader'

const App: React.FC = () => (
    <CSVReader parserOptions={{ header: true }} onFileLoaded={(data, fileInfo) => console.dir(data, fileInfo)} />
)
`}</code></pre>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <Playground __position={0} __code={'<CSVReader\n  parserOptions={{ header: true }}\n  onFileLoaded={(data, fileInfo) => console.dir(data, fileInfo)}\n/>'} __scope={{
      props,
      DefaultLayout,
      CSVReader,
      Props,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      <CSVReader parserOptions={{
        header: true
      }} onFileLoaded={(data, fileInfo) => console.dir(data, fileInfo)} mdxType="CSVReader" />
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={CSVReader} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      